export default __webpack_public_path__ + "static/media/empty-state-intermittent-faults.312234d2.svg";